import React from "react";
import AccordionItem from "./accordionItem";

export const Label = (props) => {
    return (
        <div id="label">
            <div className="container">
                <div className="section-title text-center">
                    <h2>Label</h2>
                </div>
                <div className="row">
                    {props.data ? props.data.map((d, i) => (
                        <AccordionItem key={`${d.title}-${i}`} title={d.code + ' ' + d.title}>
                            {d.files.map((f, j) => (
                                <a href={f} target="_blank" className="btn btn-custom" rel="noreferrer" key={"label" + j}>En savoir plus</a>
                            ))}
                         </AccordionItem>
                    )) : <></> }
                </div>
            </div>
        </div>
    );
};
